import { createContext, useContext, useState, useCallback } from "react";

const ToastContext = createContext(null);

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const toast = useCallback((message, type = "info") => {
    const id = Date.now() + Math.random();
    setToasts((prev) => [...prev, { id, message, type }]);
    setTimeout(() => setToasts((prev) => prev.filter((t) => t.id !== id)), 4000);
  }, []);

  const remove = (id) => setToasts((prev) => prev.filter((t) => t.id !== id));

  return (
    <ToastContext.Provider value={{ toast }}>
      {children}
      <ToastContainer toasts={toasts} onRemove={remove} />
    </ToastContext.Provider>
  );
}

function ToastContainer({ toasts, onRemove }) {
  if (!toasts.length) return null;
  return (
    <div className="fixed bottom-4 right-4 z-50 flex flex-col gap-2">
      {toasts.map((t) => (
        <Toast key={t.id} toast={t} onRemove={onRemove} />
      ))}
    </div>
  );
}

function Toast({ toast, onRemove }) {
  const colors = {
    info: "bg-dark-surface border-dark-border text-dark-text",
    success: "bg-green-900/80 border-green-700 text-green-100",
    error: "bg-red-900/80 border-red-700 text-red-100",
    warning: "bg-yellow-900/80 border-yellow-700 text-yellow-100",
  };
  return (
    <div className={`flex items-start gap-3 rounded-lg border px-4 py-3 shadow-lg text-sm max-w-sm animate-fade-in ${colors[toast.type] || colors.info}`}>
      <span className="flex-1">{toast.message}</span>
      <button onClick={() => onRemove(toast.id)} className="opacity-60 hover:opacity-100">✕</button>
    </div>
  );
}

export const useToast = () => useContext(ToastContext);
